import { CheckOutlined, DownloadOutlined } from '@ant-design/icons'
import { HTS_TAB_DETAILS } from '@Orders/constants'
import styles from '@Orders/OrderDetailsPage/styles.css'

import Box from '~/core/Box'
import Text from '~/core/Text'
import Button from '~/core/Button'
import Link from '~/core/Link'
import getColor from '~/lib/getColor'

import { CBP_FORM_LINK } from './HTSLogic'

export default function HTS5106NewInfoRequirements() {
    const CheckMark = () => {
        return (
            <CheckOutlined
                style={{
                    color: getColor('success'),
                    fontSize: 14,
                    marginRight: '7px',
                }}
            />
        )
    }

    return (
        <Box
            direction="col"
            border={`1px solid ${getColor('borderBlue')}`}
            backgroundColor="infoBackground"
            borderRadius="4px"
            width="700px"
            padding="16px"
        >
            <Text color="blackAlpha65" fontWeight={500} fontSize="16px">
                Haven’t imported internationally before?
            </Text>
            <Text fontSize="14px" style={{ padding: '16px 0' }}>
                <b>Important:</b> First time importers must have an importer
                profile in compliance with U.S Customs and Border Protection. If
                you or your business have not submitted these documents in the
                past, please prepare them by referencing the steps below. The
                carrier will reach out if document submission is required.
            </Text>
            <Text>
                1. Download and prepare the{' '}
                <Text fontWeight={400}>
                    5106 form (Customs for International Shipments)
                </Text>
            </Text>
            <Text style={{ padding: '16px 0' }}>
                2. If (a) incoterms are EXW, and (b) you don't already have this
                form on file with U.S. Customs and Border Protection CBP, you
                will be contacted by the express consignment operator (e.g.
                FedEx) to submit a completed 5106 form.
            </Text>
            <Text>
                Note: Failing to provide this form upon request will result in a
                customs hold and shipment delay.
            </Text>
            <Text style={{ paddingTop: '16px' }}>
                You will want to have the following information ready in order
                to complete the form:
            </Text>
            <Text
                fontSize="14px"
                fontWeight={400}
                style={{ paddingTop: '10px' }}
            >
                <CheckMark />
                Company EIN (tax payer ID) or your social security number
            </Text>
            <Text fontSize="14px" fontWeight={400}>
                <CheckMark />
                Company shipping and billing addresses
            </Text>
            <Box paddingTop="16px">
                <Button
                    placement={HTS_TAB_DETAILS}
                    style={{ marginRight: '10px' }}
                >
                    <DownloadOutlined style={{ marginRight: '5px' }} />
                    <Link
                        className={styles.actionableButton}
                        href={CBP_FORM_LINK}
                        target="_blank"
                        name="download5106pdf"
                        placement={HTS_TAB_DETAILS}
                    >
                        Download 5106 form
                    </Link>
                </Button>
            </Box>
        </Box>
    )
}
